import { c as _c } from "react/compiler-runtime";
import { DYNAMIC_ROUTES, STATIC_ROUTES } from 'src/constants/routes';
import useTranslations from './useTranslations';
import { useMemo } from 'react';
export const useRouteNames = () => {
  const $ = _c(67);
  const {
    t
  } = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("components.menu.routes.overview");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("components.menu.routes.insights");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("components.menu.routes.activityCenter");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("components.menu.routes.insightDetails");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("components.menu.routes.insightComments");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("common.bookMeeting");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("components.menu.routes.dashboards");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("components.menu.routes.dashboard");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("components.menu.routes.marketplace");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("components.menu.routes.sharedReport");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("components.menu.routes.switchCompany");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("components.menu.routes.profile");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("components.menu.routes.login");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t("components.menu.routes.signout");
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t) {
    t14 = t("components.menu.routes.verifyEmail");
    $[28] = t;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = t("components.menu.routes.forgotPassword");
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t) {
    t16 = t("components.menu.routes.landing");
    $[32] = t;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t) {
    t17 = t("components.menu.routes.loginWithToken");
    $[34] = t;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t) {
    t18 = t("components.menu.routes.settings");
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t) {
    t19 = t("components.menu.routes.connections");
    $[38] = t;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t) {
    t20 = t("components.menu.routes.campaigns");
    $[40] = t;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t) {
    t21 = t("components.menu.routes.knowledgehub");
    $[42] = t;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t0 || $[45] !== t1 || $[46] !== t10 || $[47] !== t11 || $[48] !== t12 || $[49] !== t13 || $[50] !== t14 || $[51] !== t15 || $[52] !== t16 || $[53] !== t17 || $[54] !== t18 || $[55] !== t19 || $[56] !== t2 || $[57] !== t20 || $[58] !== t21 || $[59] !== t3 || $[60] !== t4 || $[61] !== t5 || $[62] !== t6 || $[63] !== t7 || $[64] !== t8 || $[65] !== t9) {
    t22 = {
      [DYNAMIC_ROUTES.OVERVIEW]: t0,
      [DYNAMIC_ROUTES.INSIGHTS]: t1,
      [DYNAMIC_ROUTES.ACTIVITIES]: t2,
      [DYNAMIC_ROUTES.INSIGHTS_DETAIL]: t3,
      [DYNAMIC_ROUTES.INSIGHTS_COMMENTS]: t4,
      [DYNAMIC_ROUTES.BOOK_A_MEETING]: t5,
      [DYNAMIC_ROUTES.DASHBOARDS]: t6,
      [DYNAMIC_ROUTES.DASHBOARD_DETAIL]: t7,
      [DYNAMIC_ROUTES.MARKETPLACE]: t8,
      [DYNAMIC_ROUTES.SHARED_REPORT]: t9,
      [DYNAMIC_ROUTES.REPORT_PREVIEW]: "Preview report",
      [STATIC_ROUTES.SWITCH_COMPANY]: t10,
      [STATIC_ROUTES.PROFILE]: t11,
      [STATIC_ROUTES.LOGIN]: t12,
      [STATIC_ROUTES.SIGNOUT]: t13,
      [STATIC_ROUTES.VERIFY_EMAIL]: t14,
      [STATIC_ROUTES.FORGOT_PASSWORD]: t15,
      [STATIC_ROUTES.LANDING]: t16,
      [STATIC_ROUTES.LOGIN_WITH_TOKEN]: t17,
      [DYNAMIC_ROUTES.SETTINGS]: t18,
      [DYNAMIC_ROUTES.CONNECTIONS]: t19,
      [DYNAMIC_ROUTES.CAMPAIGNS]: t20,
      [DYNAMIC_ROUTES.ORGANIC_POSTS]: "Posts",
      [DYNAMIC_ROUTES.KNOWLEDGE_HUB]: t21,
      [DYNAMIC_ROUTES.CAMPAIGN_DETAIL]: "Campaign Details",
      [DYNAMIC_ROUTES.AD_STUDIO]: "Ad Studio",
      [DYNAMIC_ROUTES.POST_STUDIO]: "Post Studio",
      [DYNAMIC_ROUTES.MEDIA_LIBRARY]: "Media Library",
      [DYNAMIC_ROUTES.CAMPAIGN_PUBLISH]: "Publish",
      [DYNAMIC_ROUTES.DATA_EXPLORER]: "Data Explorer"
    };
    $[44] = t0;
    $[45] = t1;
    $[46] = t10;
    $[47] = t11;
    $[48] = t12;
    $[49] = t13;
    $[50] = t14;
    $[51] = t15;
    $[52] = t16;
    $[53] = t17;
    $[54] = t18;
    $[55] = t19;
    $[56] = t2;
    $[57] = t20;
    $[58] = t21;
    $[59] = t3;
    $[60] = t4;
    $[61] = t5;
    $[62] = t6;
    $[63] = t7;
    $[64] = t8;
    $[65] = t9;
    $[66] = t22;
  } else {
    t22 = $[66];
  }
  const ROUTE_NAMES = t22;
  return ROUTE_NAMES;
};